// extracted by mini-css-extract-plugin
export var container = "index-module--container--nOLHv";
export var btn = "index-module--btn--3gbA3";
export var title = "index-module--title--3gALu";
export var regionBubble = "index-module--regionBubble--3TIJ2";
export var regionBubbleAlt = "index-module--regionBubbleAlt--3ihrc index-module--regionBubble--3TIJ2";
export var regionBubbleSelected = "index-module--regionBubbleSelected--JVFwv index-module--regionBubble--3TIJ2";